module.exports = __webpack_public_path__ + "static/media/role (2).34284008.svg";